import {
  toDateKey,
  type PeriodoAutorizacao,
} from '../../people/presentation/forms/profiles/autorizacao-trabalho-remoto.utils.ts';

export type AutorizacaoTrabalhoRemotoPeriodo = PeriodoAutorizacao;

export type DiaComparecimentoPresencaInput = {
  dia: number;
  mes?: string;
  ano?: number;
  status?: string;
  remotoValidado?: boolean;
};

/** Verifica se a data (dia/mês/ano) está coberta por alguma autorização de trabalho remoto. */
export function diaDentroAutorizacaoTrabalhoRemoto(
  dia: number,
  mes: string | number,
  ano: number,
  autorizacoes: AutorizacaoTrabalhoRemotoPeriodo[] | null | undefined,
): boolean {
  if (!autorizacoes?.length) return false;
  const mesNorm = String(mes).padStart(2, '0');
  const diaNorm = String(dia).padStart(2, '0');
  const dataKey = `${ano}-${mesNorm}-${diaNorm}`;

  return autorizacoes.some((auth) => {
    const ini = toDateKey(auth.data_inicial);
    if (!ini) return false;
    const fim = toDateKey(auth.data_final) ?? '9999-12-31';
    return dataKey >= ini && dataKey <= fim;
  });
}

/**
 * Dia conta como presença no comparecimento:
 * - status presente; ou
 * - remoto validado pela corregedoria; ou
 * - remoto em dia coberto por autorização de trabalho remoto do cadastro.
 */
export function diaContaComoPresencaComparecimento(
  d: DiaComparecimentoPresencaInput,
  autorizacoes: AutorizacaoTrabalhoRemotoPeriodo[] | null | undefined,
  mesRelatorio: string | number,
  anoRelatorio: number,
): boolean {
  if (d.status === 'presente') return true;
  if (d.status !== 'remoto') return false;
  if (d.remotoValidado === true) return true;

  const mes = d.mes ?? mesRelatorio;
  const ano = d.ano ?? anoRelatorio;
  return diaDentroAutorizacaoTrabalhoRemoto(d.dia, mes, ano, autorizacoes);
}

/** Remoto ainda pendente de decisão da Corregedoria (fora de autorização de cadastro). */
export function remotoPendenteCorregedoria(
  d: DiaComparecimentoPresencaInput,
  autorizacoes: AutorizacaoTrabalhoRemotoPeriodo[] | null | undefined,
  mesRelatorio: string | number,
  anoRelatorio: number,
): boolean {
  if (d.status !== 'remoto') return false;
  if (d.remotoValidado === true) return false;
  const mes = d.mes ?? mesRelatorio;
  const ano = d.ano ?? anoRelatorio;
  return !diaDentroAutorizacaoTrabalhoRemoto(d.dia, mes, ano, autorizacoes);
}
